import { MessageType } from '../../enums/message-type';
import { TrayIcon } from '../../enums/tray-icon';
import { WebViewMessage } from './web-view-message';

export class ChangeTrayIconMessage extends WebViewMessage {
  public constructor(
    public icon: TrayIcon,
    public hoverText: string,
  ) {
    super(MessageType.ChangeTrayIconMessage);
  }
}
